<script lang="ts">
  import { seaHeightCoefficient, skyHeightCoefficient } from './pitcyFishConstants';

  export let left: number;
  export let containerWidth: number;
  export let containerHeight: number;
  $: seaHeight = containerHeight * seaHeightCoefficient;
  $: skyHeight = containerHeight * skyHeightCoefficient;
</script>

<div id="sea" style="height: {seaHeight}px; width: {containerWidth}px; top: {skyHeight}px;">
  <div class="bubbles" style="left: {left}px; width: {containerWidth}px">
    <span class="bub" style="left: {containerWidth * 0.5}px;" />
    <span
      class="bub"
      style="left: {containerWidth * 0.1}px; width: 3px;
        height: 3px; animation-delay: -16s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.15}px;
        animation-delay: -8s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.2}px; width: 3px;
        height: 3px; animation-delay: -9s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.25}px;
        animation-delay: -18s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.3}px; width: 3px;
        height: 3px; animation-delay: -2s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.35}px;
        animation-delay: -15s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.4}px; width: 3px;
        height: 3px; animation-delay: -13s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.45}px;
        animation-delay: -6s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.5}px; width: 3px;
        height: 3px; animation-delay: -1s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.55}px;
        animation-delay: -10s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.6}px; width: 3px;
        height: 3px; animation-delay: -11s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.65}px;
        animation-delay: -14s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.7}px; width: 3px;
        height: 3px; animation-delay: -2s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.75}px;
        animation-delay: 0s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.8}px; width: 3px;
        height: 3px; animation-delay: -12s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.85}px;
        animation-delay: -5s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.9}px; width: 3px;
        height: 3px; animation-delay: -9s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.95}px;
        animation-delay: -9s;"
    />
  </div>
  <div class="bubbles" style="left: {left + containerWidth}px; width: {containerWidth}px">
    <span class="bub" style="left: {containerWidth * 0.5}px;" />
    <span
      class="bub"
      style="left: {containerWidth * 0.1}px; width: 3px;
        height: 3px; animation-delay: -16s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.15}px;
        animation-delay: -8s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.2}px; width: 3px;
        height: 3px; animation-delay: -9s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.25}px;
        animation-delay: -18s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.3}px; width: 3px;
        height: 3px; animation-delay: -2s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.35}px;
        animation-delay: -15s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.4}px; width: 3px;
        height: 3px; animation-delay: -13s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.45}px;
        animation-delay: -6s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.5}px; width: 3px;
        height: 3px; animation-delay: -1s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.55}px;
        animation-delay: -10s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.6}px; width: 3px;
        height: 3px; animation-delay: -11s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.65}px;
        animation-delay: -14s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.7}px; width: 3px;
        height: 3px; animation-delay: -2s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.75}px;
        animation-delay: 0s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.8}px; width: 3px;
        height: 3px; animation-delay: -12s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.85}px;
        animation-delay: -5s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.9}px; width: 3px;
        height: 3px; animation-delay: -9s;"
    />
    <span
      class="bub"
      style="left: {containerWidth * 0.95}px;
        animation-delay: -9s;"
    />
  </div>
</div>

<style>
  #sea {
    background-image: linear-gradient(to top, rgba(84, 58, 183, 1), rgba(0, 170, 190, 1));
    position: absolute;
    z-index: 1;
    left: 0px;
    width: 100%;
  }

  /** Bubbles effect */
  .bubbles {
    position: absolute;
    height: 100%;
    top: 0px;
  }

  .bub {
    position: absolute;
    border-radius: 50%;
    width: 5px;
    height: 5px;
    background: linear-gradient(rgba(255, 255, 255, 0.625) 5%, transparent 97%);
    bottom: 0px;
    animation: sway 25s infinite ease-in 0s;
    /** give each variant an inline left, and any other variations. */
    z-index: 4;
  }

  @keyframes sway {
    20% {
      transform: translatex(-7px);
    }
    40% {
      transform: translatex(8px);
    }
    60% {
      transform: translatex(-10px);
    }
    80% {
      transform: translatex(10px);
    }
    100% {
      opacity: 0.1;
      bottom: 105%;
    }
  }
  /** End of bubbles effect css */
</style>
